// Cart Review Bar — "Learn more" opens the discount-breakdown popup.
if (!customElements.get("cart-review-bar")) {
  customElements.define(
    "cart-review-bar",
    class CartReviewBar extends HTMLElement {
      constructor() {
        super();
        this.modal = this.querySelector("[data-lm-modal]");
        this.onOpen = this.onOpen.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        this.openers = this.querySelectorAll("[data-lm-open]");
        this.closers = this.querySelectorAll("[data-lm-close]");
        this.openers.forEach((el) => el.addEventListener("click", this.onOpen));
        this.closers.forEach((el) => el.addEventListener("click", this.onClose));
      }

      disconnectedCallback() {
        this.openers?.forEach((el) => el.removeEventListener("click", this.onOpen));
        this.closers?.forEach((el) => el.removeEventListener("click", this.onClose));
        document.removeEventListener("keydown", this.onKeydown);
      }

      onOpen(event) {
        event.preventDefault();
        if (!this.modal) return;
        this.opener = event.currentTarget;
        this.modal.hidden = false;
        document.addEventListener("keydown", this.onKeydown);
        this.modal.querySelector("[data-lm-close]")?.focus();
      }

      onClose() {
        if (!this.modal || this.modal.hidden) return;
        this.modal.hidden = true;
        document.removeEventListener("keydown", this.onKeydown);
        this.opener?.focus();
      }

      onKeydown(event) {
        if (event.key === "Escape") this.onClose();
      }
    },
  );
}
